import { faCartPlus, faMinus, faPlus, faTrash, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { Currency } from "react-intl-number-format/dist/index.js";
import { useCartRequests } from '../../helpers/CartRequests';
import { setBasket } from "../stores/Cart";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Sentry } from 'react-activity';

export default function ProductCard({ product,setOpenedBox, variant =false}) {

  const {basket}=useSelector(state=>state.cart)

  const [loading,setLoading]=React.useState(false)

  const dispatch = useDispatch();
  const history = useHistory()
  const { addCart, getCart, extractionCart, decrementCart } = useCartRequests();

  const getBasket = () => {
    if (variant == false) {
      getCart().then((res) => {
        setLoading(false);
        dispatch(setBasket(res.data.data));
      });
    }
  };
  const addToBasket = async (prod, e = null) => {
    e.stopPropagation();
    setLoading(true);
    const loader = toast.loading("Ürün Sepete Ekleniyor...", {
      position: toast.POSITION.BOTTOM_RIGHT,
      isLoading: true,
      closeOnClick: false,
      pauseOnHover: false,
      pauseOnFocusLoss: false,
      draggable: false,
    });
    addCart([{ id: prod.id, count: 1 }])
      .then((res) => {
        //
        getBasket();
        const newBasket = toast.update(loader, {
          render: res.data.message,
          type: "success",
          isLoading: false,
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          pauseOnFocusLoss: false,
          draggable: true,
        });
      })
      .catch((err) => {
        setLoading(false);
        if (err.response != undefined && err.response.data.message != undefined) {
          toast.update(loader, {
            render: err.response.data.message,
            type: "error",
            isLoading: false,
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            pauseOnFocusLoss: false,
            draggable: true,
          });
          return
        }
        toast.update(loader, {
          render: "Sepet Güncellenemedi",
          type: "error",
          isLoading: false,
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          pauseOnFocusLoss: false,
          draggable: true,
        });
      });
  };

  const removeItem =async (item) => {
    const newbasket = await basket.filter((sub) => {
      return sub.productId !== item.id;
    });
    setLoading(true);
    extractionCart(item.id)
    .then((response) => {
      setLoading(false);
      dispatch(setBasket(newbasket));
    })
    .catch((error) => {
      toast.error(error.response.data.message);
    });
  }

  const decrease =async (item) => {
    setLoading(true);
    const newbasket = await basket.map((sub) => {
      if (sub.productId === item.id) {
        return {
          ...sub,
          quantity: sub.quantity - 1,
          total: sub.total - sub.price * 1,
        };
      }
      return sub;
    });
    decrementCart(item.id, 1)
    .then((response) => {
      setLoading(false);
      dispatch(setBasket(newbasket));
    })
    .catch((error) => {
      toast.error(error.response.data.message);
    });
  }
  const [rotated, setRotated] = React.useState(false);
  return (
    <>
      <div
        style={{
          width: "100vw",
          height: "100vh",
          position: "fixed",
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 100,
          top: 0,
          left: 0,
          display: rotated ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={() => setRotated(false)}
      >
        {/* <iframe
          onClick={(e) => e.stopPropagation()}
          src={
            "https://panel.360photoboxcloud.com/viewer360/viewer.html?id=" +
              product?.model || ""
          }
          style={{ width: "60vw", height: "80vh" }}
        /> */}
      </div>
      <div
        // href={`/urun/${product.slug}`}
        onClick={(e) => {
          e.stopPropagation();
          // history.push(`/urun/${product.slug}`, {
          //   prevPage: history.location.pathname,
          // });
          window.open(`/urun/${product.slug}`, "_blank");
        }}
        className="product-card"
      >
        <div
          style={{ position: "absolute" }}
          onClick={(e) => e.stopPropagation()}
        >
          {product.model != undefined &&
          product.model != null &&
          product.model != "" && false ? (
            <div
              style={{
                border: "1px solid " + (false ? "#F27A1A" : "transparent"),
                cursor: "pointer",
                borderRadius: 7,
                width: 60,
                minWidth: 60,
                maxWidth: 60,
                height: 60,
                minHeight: 60,
                maxHeight: 60,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className="product-page-items"
              onClick={() => setRotated(true)}
            >
              <img
                src={"https://cdn-icons-png.flaticon.com/512/1758/1758455.png"}
                style={{
                  borderRadius: 20,
                  width: 30,
                  minWidth: 30,
                  maxWidth: 30,
                  height: 30,
                  minHeight: 30,
                  maxHeight: 30,
                }}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
        <div
          className="overlay"
          onClick={(e) => {
            e.stopPropagation();
            dispatch(setOpenedBox(true));
          }}
        >
          <FontAwesomeIcon icon={faSearch} />
        </div>
        <div
          className="image"
          style={{ backgroundImage: `url(${product.image})` }}
        />
        <div className="variants">
          <div className="colors">
            <div></div>
            <div></div>
          </div>
          <div>{product.variantCount}</div>
        </div>
        <div className="brand">
          <span
            onClick={(e) => {
              e.stopPropagation();
              history.push(`/marka/${product.brandSlug}`);
            }}
          >
            {product.brand}
          </span>
          <span
            onClick={(e) => {
              e.stopPropagation();
              history.push(`/kategori/${product.groupSlug}`);
            }}
          >
            {product.group}
          </span>
        </div>

        <div className="name">{product.title}</div>

        {localStorage.getItem("ulusoytoken") != null ? (
          <div className="action">
            <div className="price">
              <Currency>{product.salePrice}</Currency> <span>+ KDV</span>
            </div>
            <div className="btn">
              {basket != null &&
              basket.length > 0 &&
              basket.filter((x) => x.productId == product.id).length > 0 ? (
                <div className="btn-groups">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (loading) {
                        return;
                      }
                      if (
                        basket.filter((x) => x.productId == product.id)[0]
                          .quantity == 1
                      ) {
                        removeItem(product);
                      } else {
                        decrease(product);
                      }
                    }}
                  >
                    <FontAwesomeIcon
                      icon={
                        basket.filter((x) => x.productId == product.id)[0]
                          .quantity == 1
                          ? faTrash
                          : faMinus
                      }
                    />
                  </button>
                  <div className="input">
                    {loading ? (
                      <Sentry color="#F27A1A" size={14} />
                    ) : (
                      <>
                        <input
                          type="text"
                          disabled
                          value={
                            basket.filter((x) => x.productId == product.id)[0]
                              .quantity
                          }
                        />
                        <span className="unit"> Koli</span>
                      </>
                    )}
                  </div>
                  <button
                    disabled={
                      basket.filter((x) => x.productId == product.id)[0]
                        .quantity ==
                      product.availableStock / product.unit2coefficient
                        ? true
                        : false
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      if (loading) {
                        return;
                      }
                      addToBasket(product, e);
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </button>
                </div>
              ) : (
                <button
                  className="add-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (loading) {
                      return;
                    }
                    addToBasket(product, e);
                  }}
                >
                  {/* <FontAwesomeIcon icon={faCartPlus} /> */}
                  Sepete Ekle
                </button>
              )}
            </div>
          </div>
        ) : (
          <div className="no-auth">
            Fiyatları görmek için <strong>giriş</strong> yapın
          </div>
        )}
      </div>
    </>
  );
}
